export default {
    'song':                          'Chanson',
    'about':                         'A propos',
    'add-part':                      'Ajouter une partie',
    'title':                         'Titre',
    'author':                        'Auteur',
    'album':                         'Album',
    'key':                           'Tonalité',
    'timeSignature':                 'Chiffrage',
    'capo':                          'Capo',
    'tempo':                         'Tempo',
    'part-name':                     'Nom de la partie',
    'measure-not-valid':             'Mesure non valide',
    'part-deletion':                 'Suppression d\'une partie',
    'part-delete-text1':             'ATTENTION ! Cette opération supprimera toutes les mesures présentent dans la partie.',
    'part-delete-text2':             'Êtes-vous sûr de vouloir supprimer la partie ?',
    'no':                            'Non',
    'yes':                           'Oui',
    'add-measure':                   'Ajout d\'une mesure',
    'edit-measure':                  'Modification d\'une mesure',
    'cancel':                        'Annuler',
    'valid':                         'Valider',
    'formula':                       'Formule',
    'alteration':                    'Altération',
    'root':                          'Fondamentale',
    'chord-composition':             'Composition de l\'accord',
    'delete-measure':                'Supprimer la mesure',
    'time':                          'Temps',
    'bass':                          'Basse',
    'open-repeat':                   'Renvoi début',
    'close-repeat':                  'Renvoi fin',
    'repeat':                        'Répétition',
    'repeat-measure':                'Répéter la mesure',
    'edit':                          'Édition',
    'comment':                       'Commentaire',
    'french':                        'Français',
    'english':                       'Anglais',
    'new-song':                      'Nouvelle chanson',
    'songs-list':                    'Liste des chansons',
    'save':                          'Enregistrer',
    'home':                          'Accueil',
    'song-deletion':                 'Supression d\'une chanson',
    'song-delete-text':              'Êtes-vous sûr de vouloir supprimer la chanson ?',
    'song-not-saved':                'Chanson non enregistrée',
    'close':                         'Fermer',
    'display-measure-number':        'Affichage des numéros de mesure',
    'measure-number-repeats':        'Nombre de répétitions',
    'cookies-information':           'En poursuivant votre navigation sur ce site, vous acceptez l’utilisation des cookies',
    'color':                         'Couleur',
    'color-measure':                 'Couleur de la mesure',
    'measure-color-selection':       'Couleur de la mesure',
    'save-song-error-title':         'Erreur enregistrement de la chanson',
    'save-song-error-text':          'Vous devez saisir un titre de chanson',
    'made-with':                     'Conçue avec',
    'subtitle-home':                 'Créer facilement vos grilles d\'accords',
    'description-title-home':        'Chords Grid Editor vous permet de créer et imprimer très simplement vos grilles d\'accords favorites',
    'view-song-home':                'Visualisation',
    'print-song-home':               'Imprimer vos grilles d\'accords',
    'create-your-song':              'Créer votre chanson',
    'you-can-home':                  'Vous pouvez :',
    'you-can-create-your-song-home': 'Vous pouvez dès à présent créer votre chanson',
    'create-edit-grids-home':        'Créer / Editer vos grilles d\'accords',
    'song-information-home':         'Indiquer des informations sur le morceau : la tonalité, la position du capo ainsi que le tempo',
    'colorize-measure-home':         'Coloriser vos mesures',
    'use-repeats-home':              'Utiliser les répétitions',
    'display-measures-number-home':  'Visualiser le numéro des mesures',
    'versions-history':              'Historique des versions',
    '0-2-5-title':                   'Ajout du chiffrage',
    '0-2-5-description':             'Ajout du chiffrage comme priorité d\'une chanson.',
    '0-2-6-title':                   'Ajout de l\'historique des versions',
    '0-2-6-description':             'Création d\'une page pour visualiser l\'historique des versions de l\'application.',
    '0-2-7-title':                   'Améliorations mineures',
    '0-2-7-description':             '<ul><li>Le nombre de répétitions minimum passe de 1 à 2</li><li>Mise en forme d\'une chanson</li></ul>',
    'current':                       'actuelle',
    'login-title':                   'Authentification',
    'login':                         'Identifiant',
    'password':                      'Mot de passe',
    'invalid-email':                 'Email non valide',
    'required':                      'Champs obligatoire',
    'sign-in':                       'Se connecter',
    '0-2-8-title':                   'Améliorations mineures',
    '0-2-8-description':             '<ul><li>Mise à jour des paquets</li><li>Amélioration de l\'ergonomie</li></ul>',
};
